import { render, staticRenderFns } from "./hotProducts.vue?vue&type=template&id=dca096ae&scoped=true"
import script from "./hotProducts.vue?vue&type=script&lang=js"
export * from "./hotProducts.vue?vue&type=script&lang=js"
import style0 from "./hotProducts.vue?vue&type=style&index=0&id=dca096ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca096ae",
  null
  
)

export default component.exports